module.exports = __webpack_public_path__ + "static/media/sun_w.506ddb60.svg";